import { ICON_NAVIGATION, PAGESIZE_ALL } from "app/common/LocalConst";
import { Menu } from "app/common/Model/Menu";
import {
  deleteMenu,
  getAllMenu,
  getMenuById,
  saveOrUpdateMenu,
  searchByPage,
} from "app/services/Menu";
import { pagingRoleEx } from "app/services/RoleExService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";

export default class MenuStore {
  listAllMenu = [];
  searchMenu = null;
  selectedMenu = new Menu();
  openFormCreateOrEdit = false;
  openFormAddChildren = false;
  openConfirmDeleteMenu = null;
  allRoles = [];
  hierarchyStatsData = {};
  menuFlat = [];

  constructor() {
    makeAutoObservable(this);
  }
  hierarchyStats = () => {
    const rootMenus = this.menuFlat.filter((menu) => !menu.parentId);
    const level1Menus = this.menuFlat.filter((menu) => menu?.level === 1);
    const level2Menus = this.menuFlat.filter((menu) => menu?.level === 2);
    const totalMenus = this.menuFlat.length;
    this.hierarchyStatsData = {
      rootMenus,
      level1Menus,
      level2Menus,
      totalMenus,
    };
  };

  pagingMenu = () => {
    searchByPage(this.searchMenu)
      .then(({ data }) => {
        console.log("data", data);
        this.listAllMenu = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu có lỗi");
      });
  };

  getAllMenu = () => {
    getAllMenu()
      .then(({ data }) => {
        this.listAllMenu = data;
        this.menuFlat = this.flattenMenuData(data);
        this.hierarchyStats();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu có lỗi");
      });
  };

  handleChangeFormSearch = (searchMenu) => {
    this.searchMenu = {
      ...this.searchMenu,
      ...searchMenu,
    };
    if (this.searchMenu?.keyword) {
      this.pagingMenu();
    } else {
      this.getAllMenu();
    }
  };

  handleOpenFormCreateOrEdit = (MenuId) => {
    if (Boolean(MenuId)) {
      getMenuById(MenuId)
        .then(({ data }) => {
          let formatAuth =
            data?.auth?.length > 0
              ? data?.auth?.map((el) => ({
                  name: el,
                  value: el,
                }))
              : [];
          let icon;
          if (data?.icon) {
            icon = ICON_NAVIGATION?.find((el) => el?.name === data?.icon);
          }

          this.selectedMenu = { ...data, auth: formatAuth, icon };
          this.openFormCreateOrEdit = true;
        })
        .catch((error) => {
          console.error(error);
          toast.error("Lấy dữ liệu có lỗi");
        });
    } else {
      this.selectedMenu = new Menu();
      this.openFormCreateOrEdit = true;
    }
  };

  handleAddChildren = (menu) => {
    this.selectedMenu = { parentMenu: menu, isVisible: true };
    this.openFormAddChildren = true;
  };

  saveOrUpdateMenu = (menu) => {
    let { auth, icon, ...ortherData } = menu;

    if (auth?.length > 0) {
      ortherData.auth = auth?.map((el) => el?.value);
    }

    if (icon) {
      ortherData.icon = icon?.name;
      ortherData.typeIcon = icon?.type;
    }
    return saveOrUpdateMenu(ortherData)
      .then(() => {
        this.selectedMenu = new Menu();
        toast.success("Lưu bản ghi thành công!");
        this.handleCloseFormCreateOrEdit();
        this.handleCloseFormAddChildren();
        this.getAllMenu();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lưu thông tin chiến dịch có lỗi");
      });
  };

  handleDeleteMenu = (id) => {
    this.openConfirmDeleteMenu = id;
  };

  handleCloseConfirmDeleteMenu = () => {
    this.openConfirmDeleteMenu = null;
  };

  handleConfirmDeleteMenu = () =>
    deleteMenu(this.openConfirmDeleteMenu)
      .then(() => {
        toast.success("Xóa menu thành công!");
        this.handleCloseConfirmDeleteMenu();
        this.getAllMenu()
      })
      .catch((err) => {
        console.error(err);
        toast.error("Xóa menu có lỗi");
      });

  handleGetAllRole = async () => {
    try {
      let { data } = await pagingRoleEx({
        pageIndex: 1,
        pageSize: PAGESIZE_ALL,
      });
      this.allRoles = data?.content?.map((el) => ({
        name: el?.name,
        value: el?.name,
      }));
    } catch (error) {
      toast.error("Lấy dữ liệu phân quyền có lỗi");
    }
  };

  handleCloseFormCreateOrEdit = () => {
    this.openFormCreateOrEdit = false;
    this.selectedMenu = new Menu();
  };

  handleCloseFormAddChildren = () => {
    this.openFormAddChildren = false;
    this.selectedMenu = new Menu();
  };

  flattenMenuData = (menus, level = 0) => {
    let flattened = [];
    menus.forEach((menu) => {
      flattened.push({
        ...menu,
        level: level,
        hasChildren: menu.children && menu.children.length > 0,
      });

      if (menu?.children && menu?.children?.length > 0) {
        flattened = flattened?.concat(
          this.flattenMenuData(menu?.children, level + 1)
        );
      }
    });
    return flattened;
  };
}
